export default "__VITE_ASSET__By1M9NUd__"